<template>
  <h1>
    ...to protect and preserve<br />
    the existence of waterbirds.
  </h1>
</template>


<script>
export default {
  mounted() {
    setTimeout(() => {
      this.$emit("next");
    }, 3200);
  },
};
</script>
